// extracted by mini-css-extract-plugin
export default {"content-list":"QueryRulesItems_content-list__kRtQs","contentList":"QueryRulesItems_content-list__kRtQs"};